import { appstr } from "./appstr";
import { appstrp } from "./appstrp";
import { enumLocaleOptions } from "../constants";
import { formatBackendUTCDateString } from "./formatBackendUTCDateString";
import { Globals } from "../CoreApp/Globals";

export function getReadableStringFromDateAndTime(
  dateStr,
  timeStr,
  dateFormat,
  timeFormat,
  includeTime = true,
  includeLabel = false
) {
  let d = new Date();
  let is12Hour = (timeFormat ? timeFormat : 12) === 12;
  d.convertUTCDateToLocalDate(formatBackendUTCDateString(dateStr), timeStr);

  if (!timeStr && dateStr.length === 12) {
    timeStr = dateStr.substr(dateStr.length - 4);
  }
  if (timeStr === "null") timeStr = null;

  let desiredDateStr = d.FormatDate(dateFormat);
  let desiredTimeStr = d.toLocaleString(enumLocaleOptions[Globals._stringMgr.fCurLangStr], {
    hour: "numeric",
    minute: "numeric",
    hour12: is12Hour
  });

  let prefix = includeLabel ? appstrp("lastrefresh", " ") : "";
  let completeDateTimeString;
  if (includeTime) {
    completeDateTimeString = appstr("lastrefreshdatetime", {
      date: desiredDateStr,
      time: desiredTimeStr,
      german24hour: is12Hour ? " " : " Uhr"
    });
  } else {
    completeDateTimeString = desiredDateStr;
  }

  return prefix + completeDateTimeString;
}
